var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-sticker-menu-gif" }, [
    _c("div", { staticClass: "search-bar" }, [
      _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.models.search,
            expression: "models.search",
          },
        ],
        attrs: { placeholder: _vm.$t("dash.post-creator.overlay.search") },
        domProps: { value: _vm.models.search },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.models, "search", $event.target.value)
          },
        },
      }),
    ]),
    _c("div", { staticClass: "list hide-scrollbar" }, [
      _c(
        "div",
        { staticClass: "list-stickers" },
        [
          _vm.loading
            ? _c("span", { staticClass: "loader" })
            : _vm.models.search.length ||
              (_vm.dataInstagramDefault.gifs &&
                _vm.dataInstagramDefault.gifs.length)
            ? _vm._l(
                _vm.models.search.length
                  ? _vm.gifs
                  : _vm.dataInstagramDefault.gifs,
                function (gif) {
                  return _c("div", { key: gif.id, staticClass: "gif" }, [
                    !_vm.gifLoaded[gif.id]
                      ? _c("div", { staticClass: "loader" })
                      : _vm._e(),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.gifLoaded[gif.id],
                          expression: "gifLoaded[gif.id]",
                        },
                      ],
                      key: "img" + gif.id,
                      attrs: {
                        src: gif.images.preview_gif
                          ? gif.images.preview_gif.url
                          : gif.images.original.url,
                      },
                      on: {
                        load: () => {
                          _vm.$set(_vm.gifLoaded, gif.id, true)
                        },
                        click: function ($event) {
                          return _vm.addGif(gif)
                        },
                      },
                    }),
                  ])
                }
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }